import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const MailIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <rect x="2" y="4" width="20" height="15" fill={getColor(secondaryColor)} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.612503 3.83362H23.4625V17.4062C23.4625 18.9803 22.1865 20.2562 20.6125 20.2562H3.4625C1.88849 20.2562 0.612503 18.9803 0.612503 17.4062V3.83362ZM2.3125 5.53362V17.4062C2.3125 18.0414 2.82737 18.5562 3.4625 18.5562H20.6125C21.2476 18.5562 21.7625 18.0414 21.7625 17.4062V5.53362H2.3125Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0662 13.7892L0.809959 5.2174L1.96504 3.97009L11.2213 12.5419C11.6704 12.9578 12.3666 12.949 12.8051 12.5219L21.5694 3.98487L22.7556 5.20263L13.9913 13.7397C12.9046 14.7982 11.1793 14.82 10.0662 13.7892Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.54948 12.7423L1.93698 19.1923L0.83802 17.8952L8.45052 11.4452L9.54948 12.7423Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4505 12.7423L22.063 19.1923L23.162 17.8952L15.5495 11.4452L14.4505 12.7423Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default MailIconFilled;
